import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axios';

interface BinanceAccount {
  _id: string;
  name: string;
  apiKey: string;
  apiSecret: string;
  test: boolean;
}

interface BinanceState {
  accounts: BinanceAccount[];
  status: 'idle' | 'loading' | 'failed';
}

const initialState: BinanceState = {
  accounts: [],
  status: 'idle',
};

export const fetchAccounts = createAsyncThunk('binance/fetchAccounts', async (_, thunkAPI) => {
const response = await axios.get('/binance', {});
  return response.data;
});

export const addAccount = createAsyncThunk(
  'binance/addAccount',
  async ({ name, apiKey, apiSecret }: { name: string; apiKey: string; apiSecret: string }, thunkAPI) => {
const response = await axios.post(
      '/binance/add',
      { name, apiKey, apiSecret }
    );
    return response.data.account;
  }
);

// ---- ДОБАВЛЯЕМ thunk удаления аккаунта ----
export const deleteAccount = createAsyncThunk(
  'binance/deleteAccount',
  async (id: string, thunkAPI) => {
await axios.delete(`/binance/${id}`, {});
    return id;
  }
);

const binanceSlice = createSlice({
  name: 'binance',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAccounts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.status = 'idle';
        state.accounts = action.payload;
      })
      .addCase(fetchAccounts.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(addAccount.fulfilled, (state, action) => {
        if (!state.accounts.find(acc => acc._id === action.payload._id)) {
          state.accounts.push(action.payload);
        }
        state.status = 'idle';
      })
      // ---- ОБРАБОТКА удаления аккаунта ----
      .addCase(deleteAccount.fulfilled, (state, action) => {
        state.accounts = state.accounts.filter(acc => acc._id !== action.payload);
      });
  }
});

export default binanceSlice.reducer;
